// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productPriceAndActionsStyle } from "@guestsupply/App/Components/Product/ProductPriceAndActions";
import Account from "@guestsupply/XDL/Icons/Account";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { color, createLinkIconStyles, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productPriceAndActionsStyle.productGridContainer = {
    container: {
        css: css`
            max-width: initial;
            border: none;
            padding: 0;
            ${xScreen("lte", "md")} {
                height: auto;
            }
            & > .top-section {
                margin: 0;
            }
            & > .middle-section {
                margin: 0;
            }
        `,
    },
    price: {
        css: css`
            line-height: initial;
        `,
    },
};
productPriceAndActionsStyle.productPriceStyles = {
    price: {
        priceText: {
            variant: "h2",
            forwardAs: "span",
            css: css`
                display: inline;
                line-height: 22px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 13,
                weight: 400,
                css: css`
                    line-height: 20px;
                `,
            },
        },
    },
    priceWrapper: {
        css: css`
            max-height: unset;
        `,
    },
};

productPriceAndActionsStyle.productActionsStyles = {
    addToCartContainer: {
        css: css`
            justify-content: space-between;
        `,
    },
    addToCartButtonWrapper: {
        css: css`
            flex-grow: 1;
        `,
    },
    viewOptionsButton: {
        css: css`
            margin-bottom: 2px;
        `,
    },
};
productPriceAndActionsStyle.productListProductImageStyles = {
    wrapper: {
        css: css`
            width: auto;
        `,
    },
    compareCheckbox: {
        css: css`
            margin: 0;
        `,
    },
};
productPriceAndActionsStyle.productAvailabilityStyles = {
    container: {
        css: css`
            flex: 1;
        `,
    },
};
productPriceAndActionsStyle.availabilityWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 6px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
productPriceAndActionsStyle.signInLink = {
    ...createLinkIconStyles(Account, {
        typographyProps: {
            size: 14,
            weight: "bold",
            css: css`
                line-height: 16px;
            `,
        },
        icon: {
            iconProps: {
                size: 16,
                css: css`
                    opacity: 0.33;
                    svg path {
                        fill: ${color("text.link")};
                    }
                `,
            },
            position: "left",
        },
        css: css`
            margin-top: 8px;
        `,
    }),
};

productPriceAndActionsStyle.availableOptionsLink = {
    ...createLinkIconStyles(CaretRight, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                size: 9,
            },
            position: "right",
        },
    }),
};
